import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { Call, CheckCircle, Cancel } from '@mui/icons-material';

interface CallLogHeaderProps {
  isCallAnswered: boolean;
  fullDate: string;
}

export const CallLogHeader: React.FC<CallLogHeaderProps> = ({
  isCallAnswered,
  fullDate
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Call sx={{ color: '#3b82f6', fontSize: 24 }} />
      <Box sx={{ flex: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1e293b' }}>
          Call Log Details
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
          {fullDate}
        </Typography>
      </Box>
      <Chip
        icon={isCallAnswered ? <CheckCircle /> : <Cancel />}
        label={isCallAnswered ? 'Answered' : 'No Answer'}
        size="small"
        sx={{
          backgroundColor: isCallAnswered ? '#f0fdf4' : '#fef2f2',
          color: isCallAnswered ? '#16a34a' : '#dc2626',
          border: `1px solid ${isCallAnswered ? '#bbf7d0' : '#fecaca'}`,
          fontWeight: 600
        }}
      />
    </Box>
  );
};
